import useAuth from "app/hooks/useAuth";
import AllPages from "app/routes";
import { flat } from "app/utils/utils";
import { matchPath, Navigate, useLocation } from "react-router-dom";

const userHasPermission = (pathname, routes, permissions) => {
  const matched = routes.find((r) => r.path && matchPath(r.path, pathname));
  if (!matched || !matched.permission || !matched.permission.length) {
    return true;
  }
  return Array.isArray(matched.permission)
    ? matched.permission.some((p) => permissions.includes(p))
    : permissions.includes(matched.permission);
};

const AuthGuard = ({ children }) => {
  const { isAuthenticated, permissions } = useAuth();
  const { pathname } = useLocation();
  const routes = flat(AllPages);
  const permissionList = Array.isArray(permissions) ? permissions : [];

  if (!isAuthenticated) {
    return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
  }

  if (!userHasPermission(pathname, routes, permissionList)) {
    const isDashboard = pathname.startsWith("/dashboard");
    return (
      <Navigate
        replace
        to={isDashboard ? "/profile" : "/access-denied"}
        state={isDashboard ? undefined : { from: pathname }}
      />
    );
  }

  return children;
};

export default AuthGuard;
